import { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams, Link, useLocation } from 'react-router-dom';
import dompurify from 'dompurify'

import Spinner from 'react-bootstrap/Spinner';
import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuProdutoSustentavel';
import Botao from '../../components/Botao';
import CardProdutoGenerico from '../../components/CardProdutoGenerico';
import Especies from '../../components/Especies';
import Divisor from '../../components/Divisor';
import Idiomas from '../../components/Idiomas';
import Videos from '../../components/Videos';
import Imagens from '../../components/Imagens';
import Noticias from '../../components/Noticias';

import constantes from '../../helpers/constanteHelper';
import { retornarTexto } from '../../helpers/textoHelper';
import { mostrarIdiomaProduto, validarTextoCondicionalPreenchido } from '../../helpers/idiomaHelper';

import sheetsService from '../../services/sheetsServiceProdutoSustentavel'


function DadosProdutoProdutoSustentavel() {
    const [width, setWidth] = useState(window.innerWidth);
    const [produto, setProduto] = useState({})

    const [searchParams, setSearchParams] = useSearchParams();
    const sanitizer = dompurify.sanitize;

    const navigate = useNavigate();
    const location = useLocation()

    const { slug } = useParams();

    const slugEmpresa = location?.state?.slugEmpresa

    // Controle de idioma
    const [idioma, setIdioma] = useState('pt')

    // Controle de carregamento da tela
    const [telaCarregada, setTelaCarregada] = useState(false)

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    function definirHerançaIdiomaProduto(produto) {
        let idiomaInicial = 'pt'

        if (location?.state?.idioma === 'es') {
            if (produto['Descrição do produto (Espanhol)']) {
                idiomaInicial = 'es'
            }
        } else if (location?.state?.idioma === 'en') {
            if (produto['Descrição do produto (Inglês)']) {
                idiomaInicial = 'en'
            }
        } else if (location?.state?.idioma === 'fr') {
            if (produto['Descrição do produto (Francês)']) {
                idiomaInicial = 'fr'
            }
        }

        setIdioma(idiomaInicial)
    }

    function separarItensDesseIdioma(tipoItem) {
        return produto[tipoItem]?.filter((item) => {
            if (idioma === 'pt') {
                return item['Português']?.toUpperCase() === 'X'
            } else if (idioma === 'en') {
                return item['Inglês']?.toUpperCase() === 'X'
            } else if (idioma === 'es') {
                return item['Espanhol']?.toUpperCase() === 'X'
            } else if (idioma === 'fr') {
                return item['Francês']?.toUpperCase() === 'X'
            }
        })
    }

    function retornarNomeProduto(idioma) {
        return idioma === 'en' ? produto['Nome do produto/serviço (Inglês)'] : idioma === 'es' ? produto['Nome do produto/serviço (Espanhol)'] : idioma === 'fr' ? produto['Nome do produto/serviço (Francês)'] : produto['Nome do produto/serviço']
    }

    function retornarDescricaoProduto(idioma) {
        return idioma === 'en' ? produto['Descrição do produto (Inglês)'] : idioma === 'es' ? produto['Descrição do produto (Espanhol)'] : idioma === 'fr' ? produto['Descrição do produto (Francês)'] : produto['Descrição do produto']
    }

    function retornarCategoriaProduto(idioma) {
        return idioma === 'en' ? produto['Categoria (Inglês)'] : idioma === 'es' ? produto['Categoria (Espanhol)'] : idioma === 'fr' ? produto['Categoria (Francês)'] : produto['Categoria']
    }

    function retornarSiteMaisInformacoesProduto(idioma) {
        if (idioma === 'en') {
            return produto['Link para mais informações (Inglês)'] ? produto['Link para mais informações (Inglês)'] : produto['Link para mais informações'] ? produto['Link para mais informações'] : undefined
        } else if (idioma === 'es') {
            return produto['Link para mais informações (Espanhol)'] ? produto['Link para mais informações (Espanhol)'] : produto['Link para mais informações'] ? produto['Link para mais informações'] : undefined
        } else if (idioma === 'fr') {
            return produto['Link para mais informações (Francês)'] ? produto['Link para mais informações (Francês)'] : produto['Link para mais informações'] ? produto['Link para mais informações'] : undefined
        } else {
            return produto['Link para mais informações'] ? produto['Link para mais informações'] : undefined
        }
    }

    useEffect(() => {
        sheetsService.buscarDadosProdutosSemSeparacaoPorEmpresa().then((produtosBuscados) => {
            for (let i = 0; i < produtosBuscados.length; i++) {

                if (produtosBuscados[i]['Slug (Url)'] === slug) {
                    setProduto(produtosBuscados[i])
                    definirHerançaIdiomaProduto(produtosBuscados[i])
                    setTelaCarregada(true)
                }
            }


        })
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    const regraExibicaoMenu = searchParams.get('menu')

    return (
        <>
            {telaCarregada ? <div style={{ padding: resolucaoMobile ? '0px 5px 0px 5px' : '0px', minHeight: '100vh', background: constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL }} className='text-center d-flex flex-column align-items-center'>
                {regraExibicaoMenu === 'false' ? <></> : <Menu opcaoSelecionada={'produtos'} />}
                {regraExibicaoMenu === 'false' ? <div className='mt-3'><Botao funcao={() => { navigate(`/catalogo-produto-sustentavel/empresas/${slugEmpresa}?menu=false`, { state: { idioma } }) }} largura={260} corTexto={constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL} cor={constantes.CORES.BRANCO_PADRAO} texto={retornarTexto(idioma, 'voltarParaEmpresa')} icone={'voltar'} /></div> : <></>}

                <div className='mt-5'></div>
                <div className='mt-5'></div>

                <CardProdutoGenerico produto={produto} desativarLink={regraExibicaoMenu === 'false'} idioma={idioma} pathCatalogo={'catalogo-produto-sustentavel'} />

                {mostrarIdiomaProduto(produto) ? <Idiomas
                    idioma={idioma}
                    setIdioma={setIdioma}
                    resolucaoMobile={resolucaoMobile}
                    condicaoExibirIngles={validarTextoCondicionalPreenchido(produto['Descrição do produto (Inglês)'])}
                    condicaoExibirEspanhol={validarTextoCondicionalPreenchido(produto['Descrição do produto (Espanhol)'])}
                    condicaoExibirFrances={validarTextoCondicionalPreenchido(produto['Descrição do produto (Francês)'])}
                /> : <></>}

                <h1 className='mt-5 me-2 ms-2' style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>{retornarNomeProduto(idioma)}</h1>

                <span className='mb-5' style={{ fontSize: '20px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO }}>{produto['Empresa']}</span>

                <div className={resolucaoMobile ? 'mb-5 d-flex flex-column' : 'mb-5 d-flex'} style={{ fontSize: '18px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO, marginLeft: '10px', marginRight: '10px' }}>
                    <strong>{retornarTexto(idioma, 'categoria')}:</strong>
                    <div style={resolucaoMobile ? { height: '5px' } : { width: '5px' }}></div>
                    <div dangerouslySetInnerHTML={{ __html: sanitizer(retornarCategoriaProduto(idioma)) }}></div>
                </div>

                <Especies item={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} />

                <div className='mt-5'></div>
                <Divisor />

                <div dangerouslySetInnerHTML={{ __html: sanitizer(retornarDescricaoProduto(idioma)) }} className='mt-5 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center', }}></div>

                {produto['Link para imagem adicional'] ? <Image className='mb-5' style={{ borderRadius: '10px', maxWidth: resolucaoMobile ? '90vw' : '100vw', objectFit: 'contain' }} src={produto['Link para imagem adicional']} alt='logo' fluid /> : <></>}

                {produto['Link para mais informações'] ? <Link className='mb-3' style={{ textDecoration: 'none' }} to={retornarSiteMaisInformacoesProduto(idioma)} target='_blank' rel='noopener noreferrer'>
                    <Botao cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL} largura={300} icone={'buscar'} texto={retornarTexto(idioma, 'maisInformacoes')} />
                </Link> : <></>}

                {produto['Link para a bula'] ? <Link className='mb-5' style={{ textDecoration: 'none' }} to={produto['Link para a bula']} target='_blank' rel='noopener noreferrer'>
                    <Botao cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL} largura={300} icone={'bula'} texto={retornarTexto(idioma, 'bula')} />
                </Link> : <></>}

                {produto['Vídeos'] ? <><Divisor />
                    <Videos item={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} /></>
                    : <></>}

                {produto['Imagens'] && separarItensDesseIdioma('Imagens').length > 0 ? <>
                    <Divisor />
                    <Imagens imagens={separarItensDesseIdioma('Imagens')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>}

                {produto['Notícias'] && separarItensDesseIdioma('Notícias').length > 0 ? <>
                    <Divisor />
                    <Noticias noticias={separarItensDesseIdioma('Notícias')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>}

                <div className='mt-5'></div>

            </div> : <div style={{ minHeight: '100vh', background: constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL }} className='d-flex flex-column align-items-center'>
                <div style={{ height: '100vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                    <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                    <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>{retornarTexto(idioma, 'carregandoDadosParte1')}<br />{retornarTexto(idioma, 'carregandoDadosParte2')}</span>
                </div>
            </div>}
        </>
    );
}

export default DadosProdutoProdutoSustentavel;
